var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5714 10.5714V13.4286C10.5714 13.7442 10.3156 14 10 14C9.68441 14 9.42857 13.7442 9.42857 13.4286V10.5714H6.57143C6.25584 10.5714 6 10.3156 6 10C6 9.68441 6.25584 9.42857 6.57143 9.42857H9.42857V6.57143C9.42857 6.25584 9.68441 6 10 6C10.3156 6 10.5714 6.25584 10.5714 6.57143V9.42857H13.4286C13.7442 9.42857 14 9.68441 14 10C14 10.3156 13.7442 10.5714 13.4286 10.5714H10.5714Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCartIcon);
export default __webpack_public_path__ + "static/media/add-cart-icon.561be729abbeacb384a68321820fb59d.svg";
export { ForwardRef as ReactComponent };